import { Api } from '../api';

type RequestType = 'get' | 'post' | 'put';

export const request = async <T>(type: RequestType, url: string, data?: unknown): Promise<T> => {
    try {
        let request;

        switch (type) {
            case 'get':
                request = await Api.get<T>(url);
                break;
            case 'post':
                request = await Api.post<T>(url, data);
                break;
            case 'put':
                request = await Api.put<T>(url, data);
                break;
            default:
                break;
        }

        return request?.data;
    } catch (error: any) {
        throw error?.response?.data?.error ? new Error(error.response.data.error) : error;
    }
};
